<template>

  <main>
    <sidebarNavigation></sidebarNavigation>

      <router-view></router-view>

  </main>
</template>



<script>

import habout from "./header.vue";
import sidebarNavigation from "./aside.vue";
import links from "./footer.vue";
import works from "./works.vue";

export default {
  name: "app",
  components: {
    habout,
    sidebarNavigation,
    links,
    works
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Lato", sans-serif;
}
main {
  padding-left: 60px;
  box-sizing: border-box;
}

.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  min-height: 100vh;
  /* margin-bottom: 25px; */
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}




@media (max-width: 560px) {
  main {
    padding-top: 60px;
    padding-left: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue